
import { defineComponent, PropType, ref, watch } from "vue";
import TUIViewer from "../../components/application/TUIViewer.vue";
import TUIEditor from "../../components/TUIEditor.vue";
import { QuestionForm } from "../../../../domain/entities/search-form/question_form";

type Q = {
  question: QuestionForm;
  response?: { type: number; answerText: string };
};

export default defineComponent({
  name: "QuestionFormText",
  components: { TUIViewer, TUIEditor },
  props: {
    question: {
      type: Object as PropType<Q>,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const answerText = ref<string>(props.question.response?.answerText || "");

    watch(
      () => props.question.response?.answerText,
      newVal => {
        answerText.value = newVal || "";
      },
      { immediate: true }
    );

    function getAnswerText() {
      return answerText.value;
    }

    return { answerText, getAnswerText };
  }
});
